// Little-endian codec for the 10-byte per-ship record. Must match the Go
// implementation in backend/wire/ship_record.go exactly.
//
// ShipRecord shape (decoded):
//   {
//     viewscreenId: number,   // 0..255
//     rotation: number,       // 0..255 → 0..2π
//     posX: number,           // scanner-relative, int16 range
//     posY: number,
//     velX: number,           // 10-bit signed, -512..+511
//     velY: number,
//     sprite: number,         // raw sprite byte (selector|color|flags)
//     shield: number,         // 0..15
//   }

export const ShipRecordBytes = 10

export const SpriteFlagRocket = 1 << 6
export const SpriteFlagActive = 1 << 7

export function decodeShipRecord(view, offset) {
  const viewscreenId = view.getUint8(offset)
  const rotation = view.getUint8(offset + 1)
  const posX = view.getInt16(offset + 2, true)
  const posY = view.getInt16(offset + 4, true)
  const packed = view.getUint32(offset + 6, true)
  const velXraw = packed & 0x3ff
  const velYraw = (packed >>> 10) & 0x3ff
  const sprite = (packed >>> 20) & 0xff
  const shield = (packed >>> 28) & 0x0f
  return {
    viewscreenId,
    rotation,
    posX,
    posY,
    velX: velXraw >= 0x200 ? velXraw - 0x400 : velXraw,
    velY: velYraw >= 0x200 ? velYraw - 0x400 : velYraw,
    sprite,
    shield,
  }
}

export function encodeShipRecord(view, offset, rec) {
  view.setUint8(offset, rec.viewscreenId & 0xff)
  view.setUint8(offset + 1, rec.rotation & 0xff)
  view.setInt16(offset + 2, rec.posX, true)
  view.setInt16(offset + 4, rec.posY, true)
  // bytes 6..9: [vel_x(10) | vel_y(10) | sprite(8) | shield(4)] little-endian.
  const vx = rec.velX & 0x3ff
  const vy = rec.velY & 0x3ff
  const sp = rec.sprite & 0xff
  const sh = rec.shield & 0x0f
  const packed = (vx | (vy << 10) | (sp << 20) | (sh << 28)) >>> 0
  view.setUint32(offset + 6, packed, true)
}

export function spriteSelector(sprite) {
  return sprite & 0x07
}

export function spriteColor(sprite) {
  return (sprite >>> 3) & 0x07
}

export function spriteRocketOn(sprite) {
  return (sprite & SpriteFlagRocket) !== 0
}

export function spriteActive(sprite) {
  return (sprite & SpriteFlagActive) !== 0
}
